/** Returns a copy of `list` with `item` added, or removed if it was already in there. */
export const toggleItem = <T>(list: T[], item: T): T[] =>
    list.includes(item) ? list.filter(entry => entry !== item) : [...list, item];
